export function scrollToRef(ref, { behavior = 'smooth', block = 'center' } = {}) {
  if (ref && ref.current) {
    ref.current.scrollIntoView({
      behavior,
      block
    });
  }
}

export const moveScrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
